module.exports = __webpack_public_path__ + "img/flag_rect_136.7ed02579.png";